// Simple toast utility using Bootstrap toast
export const showToast = (message, type = 'info') => {
  // Remove any existing toasts
  const existingToasts = document.querySelectorAll('.toast-container');
  existingToasts.forEach(toast => toast.remove());

  // Create toast container
  const toastContainer = document.createElement('div');
  toastContainer.className = 'toast-container position-fixed top-0 end-0 p-3';
  toastContainer.style.zIndex = '9999';

  // Create toast element
  const toastElement = document.createElement('div');
  toastElement.className = `toast show`;
  toastElement.setAttribute('role', 'alert');
  toastElement.setAttribute('aria-live', 'assertive');
  toastElement.setAttribute('aria-atomic', 'true');

  // Set background color based on type
  let bgColor = 'bg-info';
  if (type === 'error' || type === 'danger') bgColor = 'bg-danger';
  if (type === 'success') bgColor = 'bg-success';
  if (type === 'warning') bgColor = 'bg-warning';

  toastElement.innerHTML = `
    <div class="toast-header ${bgColor} text-white">
      <strong class="me-auto">
        ${type === 'error' ? 'Error' : type === 'success' ? 'Success' : 'Notification'}
      </strong>
      <button type="button" class="btn-close btn-close-white" data-bs-dismiss="toast" aria-label="Close"></button>
    </div>
    <div class="toast-body">
      ${message}
    </div>
  `;

  // Add close functionality
  const closeButton = toastElement.querySelector('.btn-close');
  closeButton.addEventListener('click', () => {
    toastContainer.remove();
  });

  // Add to container and body
  toastContainer.appendChild(toastElement);
  document.body.appendChild(toastContainer);

  // Auto remove after 5 seconds
  setTimeout(() => {
    if (document.body.contains(toastContainer)) {
      toastContainer.remove();
    }
  }, 5000);
};
